import React from 'react';
import { useIntl, defineMessage } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { LockedControl } from '../LockedControl/LockedControl';
import { SMLUpgradeFeature } from '../../config/music24PlanCapabilities';
import { Panel, PanelBody, PanelHead } from '../primitives/Panel';
/* eslint-disable css-modules/no-unused-class */
import styles from './TrendsSummaryPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

const messages = {
  kicker: defineMessage({ id: 'app.sml.aiInsights.kicker', defaultMessage: 'AI daily brief' }),
  locked: defineMessage({ id: 'app.sml.trends.ai.locked', defaultMessage: 'AI summaries come with paid plans' }),
  upgrade: defineMessage({ id: 'app.sml.trends.ai.upgrade', defaultMessage: 'Upgrade' }),
};

interface Props {
  onUpgrade: () => void;
}

/** Design n: the panel · Trends → AI daily brief row. Free has no AI credits at all, so the
 * panel never asks the server for one. */
const SummaryLockedViewComponent: React.FC<Props> = ({ onUpgrade }) => {
  const intl = useIntl();
  return (
    <Panel className={styles.panel}>
      <PanelHead title={intl.formatMessage(messages.kicker)} />
      <PanelBody>
        <span className={styles.errorPill}>
          {intl.formatMessage(messages.locked)}{' '}
          <LockedControl
            variant="link"
            feature={SMLUpgradeFeature.aiInsights}
            onClick={onUpgrade}
            label={intl.formatMessage(messages.upgrade)}
          />
        </span>
      </PanelBody>
    </Panel>
  );
};

export const SummaryLockedView = TypedMemo(SummaryLockedViewComponent);
